import type { FC } from 'react';

import { SplitView as SplitViewComponent } from '@eneco/components/SplitView/SplitView';
import { Grid, Stack, Stretch } from '@eneco/sparky';
import { Placeholder } from '@sitecore/common';
import { SplitViewRendering } from '@sitecore/types/manual/SplitView';

const SplitView: FC<SplitViewRendering> = ({ params, placeholders }) => {
  const { bringToFront, backgroundFirst, backgroundSecond, columnArrangement, columnAlignment } = params ?? {};

  const firstHasImage = placeholders?.['jss-split-view-first']?.some(r => r.componentName === 'Image');
  const secondHasImage = placeholders?.['jss-split-view-second']?.some(r => r.componentName === 'Image');

  return (
    <SplitViewComponent columnArrangement={columnArrangement} columnAlignment={columnAlignment}>
      <SplitViewComponent.Item backgroundColor={backgroundFirst} bringToFront={bringToFront === 'first'}>
        <Stretch height>
          <Stack gap={6}>
            {firstHasImage ? (
              <Grid gridTemplateColumns="40px auto 1fr" gridTemplateRows="20px auto 1fr">
                <Grid.Item gridColumn="1 / -1" gridRow="1 / -1">
                  <Placeholder name="jss-split-view-first" />
                </Grid.Item>
                <Grid.Item gridColumn="1 / -1" gridRow="1 / -1">
                  <Placeholder name="jss-promo-box" />
                </Grid.Item>
              </Grid>
            ) : (
              <Placeholder name="jss-split-view-first" />
            )}
          </Stack>
        </Stretch>
      </SplitViewComponent.Item>
      <SplitViewComponent.Item backgroundColor={backgroundSecond} bringToFront={bringToFront === 'second'}>
        <Stretch height>
          <Stack gap={6}>
            {secondHasImage ? (
              <Grid gridTemplateColumns="40px auto 1fr" gridTemplateRows="20px auto 1fr">
                <Grid.Item gridColumn="1 / -1" gridRow="1 / -1">
                  <Placeholder name="jss-split-view-second" />
                </Grid.Item>
                <Grid.Item gridColumn="1 / -1" gridRow="1 / -1">
                  <Placeholder name="jss-promo-box" />
                </Grid.Item>
              </Grid>
            ) : (
              <Placeholder name="jss-split-view-second" />
            )}
          </Stack>
        </Stretch>
      </SplitViewComponent.Item>
    </SplitViewComponent>
  );
};

export { SplitView };
export default SplitView;
